export const PRIVATE = 'private'
export const PERSONAL = 'personal'
export const PUBLIC = 'public'

export const types = {
  PUBLIC: 'public',
  PRIVATE: 'private',
  PERSONAL: 'personal',
}
